import { ShopType } from '../../types/shop.types';
import ShopRatingBar from './ShopRatingBar';

type Props = {
  feedbacks: ShopType['feedbacks'];
};

const ShopRatingDetails = (props: Props) => {
  const { feedbacks = { total: 0, fives: 0, fours: 0, threes: 0, twos: 0, ones: 0 } } = props;

  // Render image
  return (
    <div className="shop-rating-details">
      <ShopRatingBar label="5" count={feedbacks.fives} total={feedbacks.total} />
      <ShopRatingBar label="4" count={feedbacks.fours} total={feedbacks.total} />
      <ShopRatingBar label="3" count={feedbacks.threes} total={feedbacks.total} />
      <ShopRatingBar label="2" count={feedbacks.twos} total={feedbacks.total} />
      <ShopRatingBar label="1" count={feedbacks.ones} total={feedbacks.total} />
    </div>
  );
};

export default ShopRatingDetails;
